import { createSlice } from "@reduxjs/toolkit";

const initialState = {
      board: Array(49).fill(""),
      isHumanTurn: true,
      winner: null,
    };

const tiles7Slice = createSlice({
    name: "tiles7Slice",
    initialState,
    reducers: {
      setBoard: (state, action) => {
        state.board = action.payload;
        return state;
      },
      setIsHumanTurn: (state, action) => {
        state.isHumanTurn = action.payload;
        return state;
      },
      setWinner: (state, action) => {
        state.winner = action.payload;
        return state;
      },
      resetTiles7Slice: (state, action) => {
        state.board = Array(49).fill("");
        state.isHumanTurn = true;
        state.winner=null;
        return state;
      },
    },
});

export const { setBoard, setWinner, setIsHumanTurn, resetTiles7Slice } =
  tiles7Slice.actions;
export default tiles7Slice;